<template>
  <div class="mt-16">
    <div v-if="comments.length" class="p-grid">
      <div v-for="comment in comments" :key="comment.id" class="p-col-4">
        <Card>
          <template #title>
            <div class="p-d-flex p-jc-between p-ai-center p-text-sm">
              <span style="font-size: 0.9rem">{{ comment.name }}</span>
              <span style="font-size: 0.9rem">{{ comment.date }}</span>
            </div>
          </template>

          <template #content>
            {{ comment.comment }}
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import PatService from "@/services/pat.service";
export default {
  name: "ClientComments",
  props: {
    patId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      comments: [],
    };
  },
  create: {},
  async created() {
    await this.getComments();
  },
  methods: {
    async getComments() {
      try {
        this.comments = await PatService.getComments(this.patId);
        return (this.loading = false);
      } catch (err) {
        this.loading = false;
        this.$toast.add({
          severity: "error",
          summary: "Erro",
          detail:
            err?.response?.data?.message || "Erro ao carregar comentários",
          life: 4000,
        });
      }
    },
  },
};
</script>
